import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-fat.svg",
  "use": "close-fat.svg-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"close-fat.svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.467 3.169A.918.918 0 103.17 4.467L6.702 8l-3.533 3.533a.918.918 0 101.298 1.298L8 9.298l3.533 3.533a.914.914 0 001.298 0 .918.918 0 000-1.298L9.298 8l3.533-3.533a.918.918 0 10-1.298-1.298L8 6.702 4.467 3.169z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol